import {
  IconSettings,
  IconCoin,
  IconBusinessplan,
  IconPrinter,
  IconFileInvoice
} from '@tabler/icons';
import { Icon } from '@iconify/react';
import peopleFill from '@iconify/icons-eva/people-fill';

const icons = {
  IconSettings,
  IconCoin,
  IconBusinessplan,
  IconPrinter,
  IconFileInvoice
};

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const customermgmt = {
  id: 'pages',
  title: 'Loans & Customer',
  type: 'group',
  children: [
    {
      id: 'customer',
      title: 'Members',
      type: 'item',
      url: '/dashboard/client',
      icon: getIcon(peopleFill),
      breadcrumbs: false
    },
    {
      id: 'membMgmt',
      title: 'Member Management',
      type: 'collapse',
      icon: icons.IconBusinessplan,
      children: [
        {
          id: 'extraRec',
          title: 'Process Receipts',
          type: 'item',
          url: '/accounts/extrareceipt',
          target: false
        },
        {
          id: 'extraSumRec',
          title: 'Receipt Summary',
          type: 'item',
          url: '/reportsnew/receiptlist',
          target: false
        },
        {
          id: 'memberBala',
          title: 'File Reports',
          type: 'item',
          url: '/accounts/memberbalances',
          target: false
        },
        {
          id: 'membSummary',
          title: 'Members by Group',
          type: 'item',
          url: '/reportsnew/membersbygroup',
          target: false
        },
        {
          id: 'membSummaryDt',
          title: 'Members by Group Detail',
          type: 'item',
          url: '/reportsnew/membersbygroupdetail',
          target: false
        },
        {
          id: 'membership',
          title: 'Full Membership',
          type: 'item',
          url: '/reports/fullmembership',
          breadcrumbs: false
        },
        {
          id: 'memberchanges',
          title: 'Membership Changes',
          type: 'item',
          url: '/reports/membershipchanges',
          breadcrumbs: false
        },
        {
          id: 'membershipstats',
          title: 'Membership Stats',
          type: 'item',
          url: '/reports/membershipstats',
          breadcrumbs: false
        },
        {
          id: 'membershipagestats',
          title: 'Membership Age Stats',
          type: 'item',
          url: '/reports/membershipagestats',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'claims',
      title: 'Claims Management',
      type: 'collapse',
      icon: icons.IconCoin,
      children: [
        {
          id: 'processClaims',
          title: 'Process Claims',
          type: 'item',
          url: '/claims/selectBatch',
          target: false
        },
        {
          id: 'memberLookup',
          title: 'Member Look Up',
          type: 'item',
          url: '/dashboard/client',
          target: false
        },
        {
          id: 'benefitsLookup',
          title: 'Benefits Look Up',
          type: 'item',
          url: '/claims/benefitsLookup',
          target: false
        },
        {
          id: 'claimsSearch',
          title: 'Search Claims',
          type: 'item',
          url: '/claims/claimsSearch',
          target: false
        },
        {
          id: 'providers',
          title: 'Provider Lookup',
          type: 'item',
          url: '/dashboard/providers',
          target: false
        },
        {
          id: 'remittance',
          title: 'Print Remittance',
          type: 'item',
          url: '/reports/remittance',
          breadcrumbs: false
        },
        {
          id: 'remittanceSelf',
          title: 'Remittance - Self',
          type: 'item',
          url: '/reports/remittanceself',
          target: false
        },
        {
          id: 'nonAwards',
          title: 'Non Awarded Claims',
          type: 'item',
          url: '/reportsnew/nonawards',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'reportsnew',
      title: 'Reports',
      type: 'collapse',
      icon: icons.IconPrinter,
      children: [
        {
          id: 'providerSummary',
          title: 'Provider Summary..',
          type: 'item',
          url: '/reportsnew/providerSummary',
          breadcrumbs: false
        },
        {
          id: 'claimsSummaries',
          title: 'Provider Claim Sum..',
          type: 'item',
          url: '/reportsnew/claimsSummary',
          breadcrumbs: false
        },
        {
          id: 'claimsProvider',
          title: 'Claims By Provider',
          type: 'item',
          url: '/reportsnew/claimsProvider',
          breadcrumbs: false
        },
        {
          id: 'selfPmtsSummary',
          title: 'Self Payments Claims',
          type: 'item',
          url: '/reportsnew/selfpmtsummary',
          breadcrumbs: false
        },
        {
          id: 'claimsByDept',
          title: 'Claims By Department',
          type: 'item',
          url: '/reportsnew/claimsDepartment',
          breadcrumbs: false
        },
        {
          id: 'claimsByDeptD',
          title: 'Claims By Dept Detail',
          type: 'item',
          url: '/reportsnew/claimsDeptDetail',
          breadcrumbs: false
        },
        {
          id: 'remittance',
          title: 'Print Remittance',
          type: 'item',
          url: '/reports/remittance',
          breadcrumbs: false
        },
        {
          id: 'remittanceSelf',
          title: 'Remittance - Self',
          type: 'item',
          url: '/reports/remittanceself',
          target: false
        },
        {
          id: 'claimsByDiagnosis',
          title: 'Claims By Diagnosis',
          type: 'item',
          url: '/reportsnew/claimsbydiagnosis',
          breadcrumbs: false
        },
        {
          id: 'claimsStats',
          title: 'Claims Statistics',
          type: 'item',
          url: '/reportsnew/claimsstatistics',
          breadcrumbs: false
        },
        {
          id: 'nonAwards',
          title: 'Non Awarded Claims',
          type: 'item',
          url: '/reportsnew/nonawards',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'accounting',
      title: 'Accounting',
      type: 'collapse',
      icon: icons.IconFileInvoice,
      children: [
        {
          id: 'provideraccount',
          title: 'Provider Accounts',
          type: 'item',
          url: '/accounts/provideraccount',
          target: false
        },
        {
          id: 'updateJournals',
          title: 'Process Journals',
          type: 'item',
          url: '/accounts/vouchers',
          target: false
        },
        {
          id: 'updateSelfJournals',
          title: 'Process Self Journals',
          type: 'item',
          url: '/accounts/selfvouchers',
          target: false
        },
        {
          id: 'provBala',
          title: 'Provider Balances',
          type: 'item',
          url: '/accounts/providerbalances',
          target: false
        },
        {
          id: 'selfBala',
          title: 'Self Pmts Balances',
          type: 'item',
          url: '/accounts/selfpmtsbalances',
          target: false
        }
      ]
    },
    {
      id: 'reports',
      title: 'Reports - Old',
      type: 'collapse',
      icon: icons.IconPrinter,
      children: [
        {
          id: 'claimsSummary',
          title: 'Provider Claim Sum..',
          type: 'item',
          url: '/reports/claimsSummary',
          breadcrumbs: false
        },
        {
          id: 'claimsProvider',
          title: 'Claims By Provider',
          type: 'item',
          url: '/reports/claimsProvider',
          breadcrumbs: false
        },
        {
          id: 'claimsDepartment',
          title: 'Claims By Department',
          type: 'item',
          url: '/reports/claimsDepartment',
          breadcrumbs: false
        },
        {
          id: 'claimsDeptDetail',
          title: 'Claims By Dept Detail',
          type: 'item',
          url: '/reports/claimsDeptDetail',
          breadcrumbs: false
        },
        {
          id: 'claimsDiagnosis',
          title: 'Claims By Diagnosis',
          type: 'item',
          url: '/reports/claimsDiagnosis',
          breadcrumbs: false
        },
        {
          id: 'claimsNonAwarded',
          title: 'Claims Non-Awarded',
          type: 'item',
          url: '/reports/claimsNonAwarded',
          breadcrumbs: false
        },
        {
          id: 'remittance',
          title: 'Print Remittance',
          type: 'item',
          url: '/reports/remittance',
          breadcrumbs: false
        },
        {
          id: 'remittanceProvider',
          title: 'Remittance - Providers',
          type: 'item',
          url: '/reports/remittanceprovider',
          breadcrumbs: false
        },
        {
          id: 'batchSummary',
          title: 'Batch Summary',
          type: 'item',
          url: '/reports/batchSummary',
          breadcrumbs: false
        },
        {
          id: 'membership',
          title: 'Full Membership',
          type: 'item',
          url: '/reports/fullmembership',
          breadcrumbs: false
        },
        {
          id: 'memberchanges',
          title: 'Membership Changes',
          type: 'item',
          url: '/reports/membershipchanges',
          breadcrumbs: false
        },
        {
          id: 'membershipstats',
          title: 'Membership Stats',
          type: 'item',
          url: '/reports/membershipstats',
          breadcrumbs: false
        },
        {
          id: 'membershipagestats',
          title: 'Membership Age Stats',
          type: 'item',
          url: '/reports/membershipagestats',
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default customermgmt;
